var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"component--wrapper"},[_c('el-row',[_c('el-col',[_c('h1',[_vm._v(_vm._s(_vm.textStep))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }